import React, { useEffect, useState } from "react";
import { FaMoneyBillWave, FaCalendarAlt, FaAlignLeft } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import CustomInput from "./customInput";
import { useWallet } from "../api/hooks/useWallet";
import { moneyFormat } from "../utils/utils";
import ErrorAlert from "./errorAlert";

const LoanInformation = ({ formData, setFormData, formErrors, networkError, onBack }) => {

    const [selectedWallet, setSelectedWallet] = useState("");

    const [wallets, setWallets] = useState([]);

    const [walletOptions, setWalletOptions] = useState([]);

    const { isLoading: isWalletLoading, data: walletsData } = useWallet();


    const maritalStatus = [
        { label: "Single", value: "single" },
        { label: "Engaged ", value: "engaged" },
        { label: "Married", value: "married" },
        { label: "Divorced", value: "divorced" },
        { label: "Widowed", value: "widowed" },
    ]

    const repaymentMethods = [
        { label: "Wallet", value: "wallet" },
        // { label: "Bank ", value: "bank" },
        { label: "Cash", value: "cash" },
        // { label: "Direct-Debit", value: "direct-debit" },
        // { label: "Others", value: "others" },
    ]
    const trueFalse = [
        { label: "Yes", value: true },
        { label: "No", value: false },

    ]


    useEffect(() => {

        if (!formErrors) return;

        console.log(formErrors, "Form errors");


    }, [formErrors])


    useEffect(() => {
        if (!walletsData) return;

        let mainOptions = [];

        if (walletsData.data?.length > 0 || walletsData.data?.length > 0) {
            let walletsArr = walletsData?.data || [];

            walletsArr = walletsArr.filter((wallet) => wallet.currency.code == "NGN");

            walletsArr.forEach(element => {
                console.log(element.wallet_number, "wallet number");

                mainOptions.push({ label: `${element.wallet_number} (${element.currency.code}) - ${moneyFormat(element.balance)}`, value: element.id })
            });

            setWallets(walletsArr);
            setWalletOptions(mainOptions)

            setSelectedWallet(
                walletsArr[0]?.wallet_number || walletsArr[0]?.id || ""
            );
        }
    }, [walletsData]);

    return (
        <div className="bg-white p-6 rounded-2xl shadow-md">
            {/* Title */}
            <h2 className="text-xl font-semibold mb-1">School Loan</h2>
            <p className="text-gray-500 text-sm mb-6">
                Let’s help you apply for a loan
            </p>

            {/* Form */}
            <div className="space-y-4">
                {/* Loan Amount */}
                <CustomInput
                    inputType="number"
                    placeholder={"How much do you want to borrow?"}
                    inputName="loan_amount"
                    label={"How much do you want to borrow?"}
                    error={formErrors?.loan_amount}
                    className="flex-1 outline-none text-gray-700"
                    value={formData.loan_amount ?? ""}
                    onChange={(e) => setFormData({ ...formData, loan_amount: e.target.value })}
                />


                {/* Purpose */}

                <CustomInput
                    inputType="text"
                    placeholder={"Purpose of Loan"}
                    inputName="description"
                    error={formErrors?.description}
                    label={"Purpose of Loan"}
                    className="flex-1 outline-none text-gray-700"
                    value={formData.description ?? ""}
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                />



                {/* Disbursement Date */}

                <CustomInput
                    inputType="date"
                    className={"flex-1 outline-none text-gray-700"}
                    inputName="desired_loan_disbursement_date"
                    label={"Disbursement Date"}
                    error={formErrors?.desired_loan_disbursement_date}
                    value={formData.desired_loan_disbursement_date ?? ""}
                    onChange={(e) =>
                        setFormData({ ...formData, desired_loan_disbursement_date: e.target.value })
                    }
                />



                {/* Marital Status */}

                <CustomInput
                    inputType="select"
                    options={maritalStatus}
                    className={"flex-1 outline-none text-gray-700"}
                    inputName="marital_status"
                    error={formErrors?.marital_status}
                    label={"Marital Status"}
                    value={formData.marital_status ?? ""}
                    onChange={(e) =>
                        setFormData({ ...formData, marital_status: e.target.value })
                    }
                />

                <CustomInput
                    inputType="select"
                    options={trueFalse}
                    className={"flex-1 outline-none text-gray-700"}
                    inputName="has_dependents"
                    label={"Do you have dependants?"}
                    error={formErrors?.has_dependents}
                    value={formData.has_dependents ?? ""}
                    onChange={(e) =>
                        setFormData({ ...formData, has_dependents: e.target.value })
                    }
                />

                {formData?.has_dependents == "true" && <CustomInput
                    inputType="number"
                    placeholder={"Enter number of dependants"}
                    inputName="no_of_dependents"
                    label={"How many dependents do you have?"}
                    error={formErrors?.no_of_dependents}
                    className="flex-1 outline-none text-gray-700"
                    value={formData.no_of_dependents ?? ""}
                    onChange={(e) => setFormData({ ...formData, no_of_dependents: e.target.value })}
                />}

                <CustomInput
                    inputType="select"
                    options={trueFalse}
                    className={"flex-1 outline-none text-gray-700"}
                    inputName="is_planning_to_relocate"
                    label={"Are you planning to relocate?"}
                    error={formErrors?.is_planning_to_relocate}
                    value={formData.is_planning_to_relocate ?? ""}
                    onChange={(e) =>
                        setFormData({ ...formData, is_planning_to_relocate: e.target.value })
                    }
                />


                {formData?.is_planning_to_relocate == "true" && <CustomInput
                    placeholder="Enter Address"
                    label={"New Relocation Address"}
                    inputName={"new_relocation_address"}
                    className="flex-1 outline-none text-gray-700 resize-none"
                    value={formData.new_relocation_address ?? ""}
                    error={formErrors?.new_relocation_address}

                    onChange={(e) =>
                        setFormData({ ...formData, new_relocation_address: e.target.value })
                    }
                />}



                {/* Preferred Repayment Method */}

                <CustomInput
                    inputType="select"
                    options={repaymentMethods}
                    className={"flex-1 outline-none text-gray-700"}
                    inputName="preferred_repayment_method"
                    error={formErrors?.preferred_repayment_method}
                    label={"Preferred Payment Method"}
                    value={formData.preferred_repayment_method ?? ""}
                    onChange={(e) =>
                        setFormData({ ...formData, preferred_repayment_method: e.target.value })
                    }
                />

                {formData?.preferred_repayment_method == "wallet" && <CustomInput
                    inputType="select"
                    options={walletOptions}
                    className={"flex-1 outline-none text-gray-700"}
                    inputName="repayment_wallet_id"
                    label={"Repayment Wallet"}
                    value={formData.repayment_wallet_id ?? ""}
                    error={formErrors?.repayment_wallet_id}
                    onChange={(e) => {
                        console.log(e.target.value);

                        setFormData({ ...formData, repayment_wallet_id: e.target.value })
                    }}
                />}



                <CustomInput
                    inputType="select"
                    options={trueFalse}
                    className={"flex-1 outline-none text-gray-700"}
                    inputName="is_house_owner"
                    label={"Do you own a house?"}
                    error={formErrors?.is_house_owner}
                    value={formData.is_house_owner ?? ""}
                    onChange={(e) =>
                        setFormData({ ...formData, is_house_owner: e.target.value })
                    }
                />

                {/* House Address */}

                <CustomInput
                    placeholder="House Address"
                    label={"House Address"}
                    inputName={"house_address"}
                    className="flex-1 outline-none text-gray-700 resize-none"
                    value={formData.house_address ?? ""}
                    error={formErrors?.house_address}
                    onChange={(e) =>
                        setFormData({ ...formData, house_address: e.target.value })
                    }
                />

                <CustomInput
                    inputType="select"
                    options={trueFalse}
                    className={"flex-1 outline-none text-gray-700"}
                    inputName="is_earning_monthly_salary"
                    label={"Do you earn a monthly salary?"}
                    error={formErrors?.is_earning_monthly_salary}
                    value={formData.is_earning_monthly_salary ?? ""}
                    onChange={(e) =>
                        setFormData({ ...formData, is_earning_monthly_salary: e.target.value })
                    }
                />



                {/* Monthly Income */}

                {formData.is_earning_monthly_salary == "true" && <CustomInput
                    inputType="number"
                    placeholder={"Monthly Salary"}
                    inputName="monthly_salary_amount"
                    label={"Monthly Salary Amount"}
                    error={formErrors?.monthly_salary_amount}
                    className="flex-1 outline-none text-gray-700"
                    value={formData.monthly_salary_amount ?? ""}
                    onChange={(e) => setFormData({ ...formData, monthly_salary_amount: e.target.value })}
                />}


                {/* Other Income */}

                {formData.is_earning_monthly_salary == "false" && <CustomInput
                    inputType="number"
                    placeholder={"Other Income"}
                    label={"Other Income Amount"}
                    inputName="other_income_amount"
                    error={formErrors?.other_income_amount}
                    className="flex-1 outline-none text-gray-700"
                    value={formData.other_income_amount ?? ""}
                    onChange={(e) =>
                        setFormData({ ...formData, other_income_amount: e.target.value })
                    }
                />}

                {/* Monthly Expenses */}

                <CustomInput
                    inputType="number"
                    placeholder="Monthly Expenses"
                    inputName="monthly_expenses"
                    label={"Monthly Expenses"}
                    error={formErrors?.monthly_expenses}

                    className="flex-1 outline-none text-gray-700"
                    value={formData.monthly_expenses ?? ""}
                    onChange={(e) =>
                        setFormData({ ...formData, monthly_expenses: e.target.value })
                    }
                />

                <ErrorAlert error={networkError} />


            </div>

            {/* Stepper Navigation */}
            {/* <div className="flex justify-between mt-6">
                <button
                    onClick={onBack}
                    className="px-6 py-2 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
                >
                    Back
                </button>
                <button
                    onClick={onNext}
                    className="px-6 py-2 rounded-full bg-red-500 text-white font-semibold hover:bg-red-600"
                >
                    Next
                </button>
            </div> */}
        </div>
    );
};

export default LoanInformation;
